import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => ({
  container: {
    padding: 12,
    background: '#f3f3f3',
    marginBottom: '1.5rem',
    borderRadius: 4,
  },
  buttonCopy: {
    marginTop: '1.5rem',
  },
  switch: {
    marginTop: '1.5rem',
  },
}));
